export default __webpack_public_path__ + "static/media/WalletPayment.a722fcc5.svg";